import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Form, FormGroup, Input, Label, ModalBody } from 'reactstrap'
import ErrorBoundary from '@/components/ErrorBoundary'
import React, { useCallback, useState } from 'react'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { useLocalization } from '@/hooks/localization'
import { getTreeCode } from '@/components/report-tables/core/utils'

function ChangeParentDialog (props) {
  const { code, treeCode, parentTreeCode, cellType, treeCodes, onAction } = props
  const { localize } = useLocalization()
  const [value, setValue] = useState((parentTreeCode !== -1 && parentTreeCode) || '')
  const onChange = useCallback(e => setValue(e.target.value || ''), [])
  const onSubmit = useCallback(() => {
    const e = { oldTreeCode: treeCode, newTreeCode: getTreeCode(value, code), parentTreeCode: value || -1, cellType }
    onAction(e)
  }, [treeCode, value, code, cellType, onAction])
  const onValidate = useCallback((e) => {
    // 1. is existing treeCode
    const newParent = e.value || -1
    if (newParent === parentTreeCode) {
      return // parent not changed
    }
    if (newParent === -1) { // moving to root
      if (treeCodes.find(x => x === code)) {
        return 'ReportDesigner.HeaderCodeSiblingConflict' // there is already header with same code under target parent
      }
    } else { // moving under existing header
      if (!treeCodes.find(x => x === newParent)) {
        return 'ReportDesigner.ParentNotFound'
      } else if (newParent.startsWith(treeCode)) {
        return 'ReportDesigner.InvalidParent'
      } else {
        const newTreeCode = getTreeCode(newParent, code)
        if (treeCodes.find(x => x === newTreeCode)) {
          return 'ReportDesigner.HeaderCodeSiblingConflict'
        }
      }
    }
  }, [code, parentTreeCode, treeCode, treeCodes])
  return (
    <ValidationBoundary>
      <BasicHeader {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Form>
            <FormGroup>
              <Label>{localize('ReportDesigner.ParentTreeCode')}</Label>
              <Validator name='parentTreeCode' value={value} onValidate={onValidate}>
                <Input value={value} onChange={onChange} />
              </Validator>
            </FormGroup>
          </Form>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={onSubmit} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: ChangeParentDialog
}



// WEBPACK FOOTER //
// ./src/components/reportDesigner/dialogs/changeParentDialog.js